import { createFileRoute } from '@tanstack/react-router';
import { TasksBoard } from '@/features/kanban/components/TasksBoard';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/tasks-board')({
  component: TasksBoardPage,
});

function TasksBoardPage() {
  return (
    <PermissionGate permission={Permission.NOTION_VIEW_KANBAN}>
      <div className="h-full flex flex-col -m-4 md:-m-6">
        <div className="flex-1 min-h-0 overflow-hidden">
          <TasksBoard />
        </div>
      </div>
    </PermissionGate>
  );
}
